<ng-rate-form
  *ngIf="(store$ | async) as store"
  (clearDynamicData)="clearDynamicData()"
  (clearStcc)="clearStcc()"
  (loadCarTypesData)="getCarTypes($event)"
  (loadDestinationStationsData)="loadDestinationStations($event)"
  (loadOriginStationsData)="loadOriginStations($event)"
  (loadStccData)="loadStcc($event)"
  (updateItem)="updateItem($event)"
  (setInquiryList)="setInquiryList($event)"
  (setDisplayForm)="setDisplayForm($event)"
  (clearRateResultsData)="clearRateResultsData()"
  (clearRateSearchList)="clearRateSearchList()"
  (favSelected)="favoritesSelected($event)"
  (searchRateInquiry)="search($event)"
  (setDisplayList)="setDisplayList($event)"
  (setCarTypes)="setCarTypes($event)"
  (setFavorite)="setFavorite($event)"
  [carOwners]="store.form.carOwners"
  [carTypes]="store.form.carTypes"
  [displayForm]="store.core.displayForm"
  [destinationStations]="store.form.destinationStations"
  [originStations]="store.form.originStations"
  [states]="store.form.states"
  [stccList]="store.form.stcc"
  [isLoadingDS]="store.form.isLoadingDS"
  [isLoadingOS]="store.form.isLoadingOS"
  [isLoadingStcc]="store.form.isLoadingStcc"
  [rateInquiryItem]="store.core.rateInquiryItem"
  [inquiryList]="store.core.inquiryList"
  [searchList]="store.core.searchList">
</ng-rate-form>
